<template lang="html">
  <d-form>
    <d-form-row>

      <!-- Name -->
      <d-col sm="6" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
          readonly
        />
      </d-col>

      <!-- Email -->
      <d-col sm="6" class="form-group">
        <label for="feContactEmail">E-mail</label>
        <d-form-input type="email" v-model="model.email" id="feContactEmail" placeholder="E-mail" readonly/>
      </d-col>

    </d-form-row>

    <d-form-row>

      <!-- Zipcode -->
      <d-col sm="3"  class="form-group">
        <label for="inputCEP">CEP</label>
        <masked-input
          type="text"
          class="text-left form-control"
          id="inputCEP"
          placeholder="00.000-000"
          :mask="[/\d/, /\d/,'.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
          :guide="false"
          v-model="model.zipcode"
          readonly
        ></masked-input>
      </d-col>

      <!-- Phone -->
      <d-col sm="3" class="form-group">
        <label for="feTelefone">Telefone</label>
        <input-phone
          id="feTelefone"
          placeholder="Telefone"
          :model.sync="model.phone"
          readonly
        ></input-phone>
      </d-col>

      <!-- Contact by -->
      <d-col sm="6" class="form-group">
        <label for="feContact">Entrar em contato por</label>
        <d-form-input v-model="model.contact_by" id="feContact" placeholder="Entrar em contato por" readonly/>
      </d-col>

    </d-form-row>

    <d-form-row>

      <!-- City -->
      <d-col sm="6" class="form-group">
        <label for="feInputCidade">Cidade</label>
        <d-form-input
          type="text"
          id="feInputCidade"
          v-model="model.city"
          readonly
        />
      </d-col>

      <!-- Country -->
      <d-col sm="4" class="form-group">
        <label for="feInputPais">País</label>
        <d-form-input
          type="text"
          id="feInputPais"
          v-model="model.country"
          readonly
        />
      </d-col>

      <!-- State -->
      <d-col sm="2" class="form-group">
        <label for="feInputState">Estado</label>
        <d-form-input
          type="text"
          id="feInputState"
          v-model="model.state"
          readonly
        />
      </d-col>

    </d-form-row>

    <d-form-row>

      <!-- Role -->
      <d-col sm="6" class="form-group">
        <label for="feInputRole">Papel na obra</label>
        <d-form-input
          type="text"
          id="feInputRole"
          v-model="model.role"
          readonly
        />
      </d-col>

      <!-- Product -->
      <d-col sm="6" class="form-group">
        <label for="feInputProduct">Produto visitado</label>
        <d-form-input
          type="text"
          id="feInputProduct"
          v-model="model.visited_product"
          readonly
        />
      </d-col>

    </d-form-row>

    <d-form-row>

      <!-- Product -->
      <d-col sm="6" class="form-group">
        <label for="feInputReseller">Loja parceira</label>
        <d-form-input
          type="text"
          id="feInputReseller"
          v-model="reseller.name"
          readonly
        />
      </d-col>

      <!-- Newsletter -->
      <d-col sm="3" class="form-group">
        <label for="feInputNewsletter">Newsletter</label>
        <d-checkbox toggle :checked="(model.newsletter == 1)" disabled class="custom-toggle-sm">Quer receber as newsletters</d-checkbox>
      </d-col>

      <!-- Colors -->
      <d-col sm="3" class="form-group">
        <label for="feInputNewsletter">Coleção</label>
        <d-checkbox toggle :checked="(model.colors == 1)" disabled class="custom-toggle-sm">Colors</d-checkbox>
      </d-col>

    </d-form-row>

  </d-form>

</template>

<script>
import { mapActions } from 'vuex';
import SelectState from '_shared/SelectState.vue';
import MaskedInput from 'vue-text-mask';
import InputPhone from '_shared/InputPhone.vue';
import Events from '_utils/events';
import { MODEL, _LOAD_MODEL_ } from './LeadModel';

export default {
  name: 'lead-form',
  components: {
    InputPhone,
    MaskedInput,
    SelectState,
  },
  data() {
    return {
      model: { ...MODEL },
      loading: false,
    };
  },
  computed: {
    reseller() {
      const { reseller } = this.$store.state.lead;
      if (reseller) {
        return reseller;
      }
      return { name: null };
    },
  },
  methods: {
    ...mapActions([
      'activeAlert',
    ]),
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
.custom-toggle-sm /deep/ .custom-control-input:checked:disabled ~ .custom-control-label::before {
    background: #17c671;
    border-color: #17c671;
}
</style>
